// src/pages/Animal.js
import React from "react";

// Import images
import animal1 from "../assets/animal1.webp";

// 🔹 Reusable Section Component
const SectionWithImages = ({ id, title, text, images, reverse = false, labels = [] }) => {
    return (
        <div id={id} className={`flex flex-col ${reverse ? "sm:flex-row-reverse" : "sm:flex-row"} items-center text-white bg-gray-900 p-12 sm:p-20 gap-8`}>
            {/* Full-Width Text for Image-less Sections */}
            <div className={`w-full ${images.length === 0 ? "text-center" : "sm:w-1/2 text-left"}`}>
                <h2 className="text-4xl sm:text-5xl font-bold mb-6 animate-fadeIn">{title}</h2>
                <p className="text-lg sm:text-xl animate-fadeIn animate-delay-300 text-justify whitespace-pre-line">{text || ""}</p>
            </div>

            {/* Images Section with Labels (only if images exist) */}
            {images.length > 0 && (
                <div className={`w-full sm:w-1/2 grid grid-cols-1 ${images.length > 1 ? "sm:grid-cols-2" : ""} gap-4`}>
                    {images.map((img, index) => (
                        <div key={index} className="flex flex-col items-center">
                            <img
                                src={img}
                                alt={`${title} ${index + 1}`}
                                className="rounded-lg shadow-lg transform hover:scale-105 transition duration-300 w-full h-64 sm:h-80 object-cover"
                            />
                            {/* Add Figure Label if Provided */}
                            {labels[index] && <p className="mt-2 text-sm sm:text-base text-gray-300">{labels[index]}</p>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const Animal = () => {
    return (
        <div className="w-full">
            {/* 🔹 Animal */}
            <SectionWithImages
                id="animal"
                title="Animal and Aquaculture Feed:"
                text="Proalgenix is developing microalgae-based solutions for the animal and aquaculture feed sector, offering sustainable components tailored to specific nutritional needs. This approach enhances the feed’s nutritional value while reducing the reliance on antibiotics, promoting environmentally responsible and sustainable aquaculture practices."
                images={[animal1]}
                reverse={true}
            />
        </div>
    );
};

export default Animal;
